import { getPositionFromAction } from "../../../helpers";
import getPreviousActionSummary from "./getPreviousActionSummary";

export default function getBreakevenValue(action, treeInfo, criteria = "ev") {
	if (criteria !== "ev") return 0;
	const prevSizingInfo = getPreviousActionSummary(action, treeInfo);
	const pos = getPositionFromAction(action.split(",").pop());
	return prevSizingInfo[pos].amountCommitted * -1000; // TODO: change if sortBy is f
}
